import React, { PureComponent } from "react";
export default class MerchantInfo extends PureComponent {
  /* Render Functions */
   render() {
 const { item } = this.props;
  return(
    <div className="col-md-12">
    {item&&item.location&&<div className="table">
      <thead>
      <th>
        Stores
      </th>
      <th>
      Address/city/state
      </th>
      </thead>
      <tbody>
       {item&&item.location&&item.location.map(itemLocation=>{
         <tr>
         <td>
           {itemLocation.stores}
         </td>
         <td>
           {itemLocation.address}
         </td>
       </tr>
       }) }
      </tbody>
    </div>}
    </div>


  )
  }
}
